import { createAction } from 'redux-actions';

export const setAutoTieoutWorkpaperReference = createAction(
  'SET_AUTO_TIEOUT_WORKPAPER_REFERENCE',
);

export const removeAutoTieoutWorkpaperReference = createAction(
  'REMOVE_AUTO_TIEOUT_WORKPAPER_REFERENCE',
);

export const setAutoTieoutStatusForBanner = createAction(
  'SET_AUTO_TIEOUT_STATUS_FOR_BANNER',
);

export const resetAutoTieoutStatusForBanner = createAction(
  'RESET_AUTO_TIEOUT_STATUS_FOR_BANNER',
);

export const autoTieoutWorkflowDataLoaded = createAction(
  'AUTO_TIEOUT_WORKFLOW_DATA_LOADED',
);

export const resetAutoTieoutWorkflowData = createAction(
  'RESET_AUTO_TIEOUT_WORKFLOW_DATA',
);

export const autoTieoutWorkflowDataLoading = createAction(
  'AUTO_TIEOUT_WORKFLOW_DATA_LOADING',
);

export const autoTieoutWorkflowDataError = createAction(
  'AUTO_TIEOUT_WORKFLOW_DATA_ERROR',
);
